import React, { useState } from "react";
import * as Icons from "../assets/SVGs/index";
import Button from "./basicComponents/button";
import { useDispatch, useSelector } from "react-redux";
import { setRowStatus } from ".././state-management/actions/global-state-actions";

interface EditButtonProps {
    id: string;
    isEditing: boolean;
    setEditingRowId?: React.Dispatch<React.SetStateAction<string | null>>;
    editable: boolean;
    handleEdit: () => Promise<void>;
    handleSetData: (clear: boolean, id: any) => Promise<void>;
}

const EditButton: React.FC<EditButtonProps> = ({
    id,
    isEditing,
    setEditingRowId,
    editable,
    handleEdit,
    handleSetData,
}) => {
    const { rowStatus } = useSelector((state: any) => state.globalState);
    const [localEditing, setLocalEditing] = useState(isEditing);

    const dispatch = useDispatch();

    const handleEditBtn = () => {
        handleSetData(false, id);
        if (editable) {
            if (setEditingRowId) setEditingRowId(id);
            setLocalEditing(true);

            dispatch(setRowStatus(id, true));
        } else {
            if (setEditingRowId) setEditingRowId(id);
            setLocalEditing(true);
            dispatch(setRowStatus(id, true));
        }
    };

    const handleCancel = () => {
        handleSetData(true, id);
        if (setEditingRowId) setEditingRowId(null);
        setLocalEditing(false);
        dispatch(setRowStatus(id, false));
    };
    const handleSave = (id: string) => {
        if (handleEdit) {
            handleEdit();
        }
        console.log(`Saving item with id: ${id}`);
    };

    return (
        <>
            <Button
                title=""
                icon={
                    localEditing && (rowStatus.status || editable) ? (
                        <div className="flex items-center gap-x-2 ">
                            {editable && rowStatus.status ? (
                                <Icons.SaveIcon
                                    onClick={() => handleSave(id)}
                                />
                            ) : null}
                            <Icons.CloseIcon fill="red" />
                        </div>
                    ) : (
                        <Icons.EditIcon fill="none" style={{ stroke: "red" }} />
                    )
                }
                onClick={localEditing ? handleCancel : handleEditBtn}
            />
        </>
    );
};

export default EditButton;
